import { render, staticRenderFns } from "./DD_Dashboard.vue?vue&type=template&id=248f9b35&scoped=true&"
import script from "./DD_Dashboard.vue?vue&type=script&lang=js&"
export * from "./DD_Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./DD_Dashboard.vue?vue&type=style&index=0&id=248f9b35&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248f9b35",
  null
  
)

export default component.exports